/* Prezently — warstwa własna. Animacje wejścia, wysokość paska promocyjnego, liczniki. */
(function () {
  'use strict';
  if (window.__pzInit) return;
  window.__pzInit = true;

  var mniejRuchu = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. wysokość paska promocyjnego -> --pz-cd-h ---------- */
  function mierzPasek() {
    var pasek = document.querySelector('.pz-cd-sec');
    var h = pasek ? Math.round(pasek.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--pz-cd-h', h + 'px');
  }
  function pilnujPaska() {
    mierzPasek();
    var pasek = document.querySelector('.pz-cd-sec');
    if (pasek && window.ResizeObserver) new ResizeObserver(mierzPasek).observe(pasek);
    window.addEventListener('load', mierzPasek);
    window.addEventListener('resize', mierzPasek);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(mierzPasek);
  }

  /* ---------- 2. liczniki ---------- */
  function dwie(n) { return n < 10 ? '0' + n : '' + n; }

  function tykaj(el) {
    var doKiedy = Date.parse(el.getAttribute('data-pz-do'));
    if (isNaN(doKiedy)) return;
    var tryb = el.getAttribute('data-pz-tryb') || 'zegar';
    function krok() {
      var r = Math.max(0, doKiedy - Date.now());
      var s = Math.floor(r / 1000);
      var d = Math.floor(s / 86400);
      var g = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sek = s % 60;
      if (tryb === 'bloki') {
        var pola = el.querySelectorAll('[data-pz-u]');
        for (var i = 0; i < pola.length; i++) {
          var u = pola[i].getAttribute('data-pz-u');
          pola[i].textContent = u === 'd' ? d : u === 'g' ? dwie(g) : u === 'm' ? dwie(m) : dwie(sek);
        }
      } else {
        el.textContent = (d > 0 ? d + 'd ' : '') + dwie(g) + ':' + dwie(m) + ':' + dwie(sek);
      }
    }
    krok();
    setInterval(krok, 1000);
  }

  function liczniki() {
    var el = document.querySelectorAll('[data-pz-do]');
    for (var i = 0; i < el.length; i++) {
      if (el[i].__pz) continue;
      el[i].__pz = 1;
      tykaj(el[i]);
    }
  }

  /* ---------- 3. animacje wejścia ---------- */
  function ukryj(el) {
    el.style.transition = 'none';
    el.classList.add('is-off');
    void el.offsetWidth;
    el.style.transition = '';
  }

  function odsloniec(el, opoznienie) {
    setTimeout(function () { el.classList.remove('is-off'); }, opoznienie || 0);
  }

  function reveal() {
    if (mniejRuchu) return;
    var cele = document.querySelectorAll('.pz-r, .pz-rx');
    if (!cele.length) return;
    var i;
    for (i = 0; i < cele.length; i++) {
      if (cele[i].__pzr) continue;
      cele[i].__pzr = 1;
      ukryj(cele[i]);
    }
    if (!('IntersectionObserver' in window)) {
      for (i = 0; i < cele.length; i++) cele[i].classList.remove('is-off');
      return;
    }
    var obs = new IntersectionObserver(function (wpisy) {
      for (var j = 0; j < wpisy.length; j++) {
        if (!wpisy[j].isIntersecting) continue;
        var el = wpisy[j].target;
        var rodzenstwo = el.parentElement ? el.parentElement.querySelectorAll(':scope > .pz-rx') : [];
        var idx = Array.prototype.indexOf.call(rodzenstwo, el);
        odsloniec(el, idx > 0 ? idx * 95 : 0);
        obs.unobserve(el);
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    for (i = 0; i < cele.length; i++) obs.observe(cele[i]);

    /* bezpiecznik: gdyby strona nie komponowała klatek, odsłoń wszystko */
    setTimeout(function () {
      var nieprzewijalna = document.documentElement.scrollHeight <= window.innerHeight + 4;
      if (window.innerWidth === 0 || nieprzewijalna) {
        var w = document.querySelectorAll('.pz-r.is-off, .pz-rx.is-off');
        for (var k = 0; k < w.length; k++) w[k].classList.remove('is-off');
      }
    }, 2500);
  }

  /* ---------- 4. newsletter: komunikat po wysyłce ---------- */
  function newsletter() {
    if (!/customer_posted=true/.test(window.location.search)) return;
    var ok = document.querySelectorAll('[data-pz-nl-ok]');
    for (var i = 0; i < ok.length; i++) ok[i].hidden = false;
  }

  function start() {
    pilnujPaska();
    liczniki();
    reveal();
    newsletter();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', function () {
    window.__pzInit = true;
    mierzPasek();
    liczniki();
    reveal();
  });
})();

/* Polskie etykiety dla czytników ekranu tam, gdzie Shrine ma je na sztywno po angielsku
   albo brakuje mu tłumaczenia (np. „Translation missing: pl.accessibility.scroll_to_top"). */
(function () {
  'use strict';
  var MAPA = {
    'Price range slider': 'Zakres cen',
    'Minimum price': 'Cena minimalna',
    'Maximum price': 'Cena maksymalna',
    'Translation missing: pl.accessibility.scroll_to_top': 'Przewiń do góry'
  };
  function spolszcz(root) {
    var el = (root || document).querySelectorAll('[aria-label]');
    for (var i = 0; i < el.length; i++) {
      var v = el[i].getAttribute('aria-label');
      if (MAPA[v]) el[i].setAttribute('aria-label', MAPA[v]);
      else if (v && v.indexOf('Translation missing') === 0) el[i].removeAttribute('aria-label');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { spolszcz(); });
  else spolszcz();
  document.addEventListener('shopify:section:load', function (e) { spolszcz(e.target); });
  // filtry kolekcji przeładowują się bez odświeżenia strony
  if ('MutationObserver' in window) {
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(spolszcz, 150); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
